// extracted by mini-css-extract-plugin
export default {"exactPriceBlock":"classes@desktop_exactPriceBlock__vxtLB","exactPriceBlockContent":"classes@desktop_exactPriceBlockContent__ja8fK"};